// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3Ss9Z","content":"Consent_content__3EpIN","footer":"Consent_footer__k8K2j"};